export const ACCOUNTING_SUBJECT_VOCABULARY = {
  sourceTypes: {
    CHECKOUT_ORDER: 'checkout-order',
  },
  contextTypes: {
    CHECKOUT_ID: 'checkoutId',
    ORDER_ID: 'orderId',
    PAYMENT_ID: 'paymentId',
    EXECUTION_ID: 'executionId',
  },
  reasons: {
    ISSUANCE_CHANGED: 'issuance-changed',
    PAYMENT_PAID: 'payment-paid',
    DOCUMENT_BOUND: 'document-bound',
    PRINTOUT_ATTACHED: 'printout-attached',
  },
} as const;
